export default __webpack_public_path__ + "static/media/ic-search.9ac48425.svg";